import { isFutureReservationDateTime } from "@/utils/reservationDateTime";

export default {
  canRequestReschedule(item, now = new Date()) {
    return Boolean(
      item &&
        item.bookingType !== "offline" &&
        ["request", "confirmed"].includes(item.status) &&
        isFutureReservationDateTime(item.date, item.time, now)
    );
  },
  hasPendingReschedule(item) {
    return Boolean(
      item &&
        item.rescheduleRequest &&
        item.rescheduleRequest.status === "pending"
    );
  },
  openRescheduleDialog(item) {
    if (!this.canRequestReschedule(item)) return;
    this.rescheduleSchedule = item;
    this.showRescheduleDialog = true;
  },
  closeRescheduleDialog() {
    this.showRescheduleDialog = false;
    this.rescheduleSchedule = null;
  },
  handleRescheduleSubmitted() {
    this.closeRescheduleDialog();
    this.loadSchedules();
  },
};
